var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_592)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43325 2.16669H6.56659C3.86387 2.16669 2.51251 2.16669 1.67288 3.0094C0.833252 3.85211 0.833252 5.20843 0.833252 7.92109V8.28075C0.833252 10.9934 0.833252 12.3497 1.67288 13.1924C2.06017 13.5811 2.60483 13.8405 3.30902 13.9706C3.52531 14.0106 3.63345 14.0305 3.68041 14.0983C3.72739 14.1662 3.70809 14.2742 3.66952 14.4901C3.57612 15.013 3.59088 15.4857 3.92617 15.7364C4.27755 15.9929 4.83747 15.7188 5.95732 15.1708C6.08136 15.1101 6.20584 15.0479 6.33056 14.9856L6.33246 14.9846C6.99732 14.6522 7.67485 14.3136 8.39738 14.1466C8.71165 14.0748 9.03158 14.0441 9.43325 14.0351C12.136 14.0351 13.4873 14.0351 14.327 13.1924C15.1666 12.3497 15.1666 10.9934 15.1666 8.28075V7.92109C15.1666 5.20843 15.1666 3.85211 14.327 3.0094C13.4873 2.16669 12.136 2.16669 9.43325 2.16669ZM11.1666 10C11.1666 10.2762 10.9427 10.5 10.6666 10.5H5.33325C5.05711 10.5 4.83325 10.2762 4.83325 10C4.83325 9.72389 5.05711 9.50002 5.33325 9.50002H10.6666C10.9427 9.50002 11.1666 9.72389 11.1666 10ZM8.49992 6.66669C8.49992 6.94283 8.27605 7.16669 7.99992 7.16669H5.33325C5.05711 7.16669 4.83325 6.94283 4.83325 6.66669C4.83325 6.39055 5.05711 6.16669 5.33325 6.16669H7.99992C8.27605 6.16669 8.49992 6.39055 8.49992 6.66669Z",
    fill: "#172B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.243683d02443018090bc80adfe3e4fae.svg";
export { ForwardRef as ReactComponent };